import { ValidatorFn, FormGroup, ValidationErrors, FormArray } from '@angular/forms';

export function atLeastOneFieldValidator(): ValidatorFn {
  return (formGroup: FormGroup): ValidationErrors | null => {
    const hasAtLeastOneValue = Object.values(formGroup.controls).some(control => {
      if (control instanceof FormGroup || control instanceof FormArray) {
        return atLeastOneFieldValidator()(control as FormGroup) === null;
      }
      return control.value != null && control.value !== '';
    });

    return hasAtLeastOneValue ? null : { atLeastOneRequired: true };
  };
}




// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/validators/atLeastOneFieldValidator.ts